exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "p,ul{margin:0;padding:0}.full-calendar-body{margin-top:20px}.weeks{display:flex;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;border-left:1px solid #e0e0e0}.week{flex:1;padding:5px;text-align:center;border-right:1px solid #e0e0e0}.dates{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-ff4575d8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Calendar.vue
// module id = 139
// module chunks = 0 1